import { capworksSignupService } from "@/modules/capworks/features/signup/store/services/capworks-signup-service";

const parseProgramFileEndpoint = capworksSignupService.injectEndpoints({
  endpoints: (builder) => ({
    parseProgramFile: builder.mutation({
      query: ({ file, token, pageUrl }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("token", token);
        formData.append("pageUrl", pageUrl);

        return {
          url: "auth/signup/parse-program-file",
          method: "POST",
          body: formData,
        };
      },
      extraOptions: { suppressNotification: true },
    }),
  }),
  overrideExisting: false,
});

export const { useParseProgramFileMutation } = parseProgramFileEndpoint;

